module.exports = __webpack_public_path__ + "media/customizations/heritagelife/back-2ab2bc3a2e0c9750d67f701ee5b61382.jpg";